import { defineMessages } from 'react-intl';

export default defineMessages({
  minValue: {
    id: 'general.datable.filterDate.minValue',
    defaultMessage: 'Début',
  },
  maxValue: {
    id: 'general.datable.filterDate.maxValue',
    defaultMessage: 'Fin',
  },
});
